module.exports = __webpack_public_path__ + "img/sule.e3205c0b.jpeg";